<template>
  <app-tooltip>
    <slot/>

    <template #tooltip>
      Coming soon
    </template>
  </app-tooltip>
</template>
